import { ReportsRoutePath } from "#src/routes/reports";
import { RoutePath } from "#src/utils/route";

export const TemplatedReportsListRoutePath = ReportsRoutePath.concat(
  new RoutePath<string, "tab">({
    path: "/templated-reports",
    title: "Templated Reports",
  })
);
